import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { ROUTES } from "../config/routes";

export const CTA = () => (
  <section id="cta" data-testid="cta" className="px-6 py-28 md:px-12 lg:px-24">
    <div className="relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] border border-line bg-ink px-8 py-20 text-center md:px-16 md:py-28">
      <div className="pointer-events-none absolute -left-20 top-1/2 h-72 w-72 -translate-y-1/2 rounded-full bg-lime/30 blur-[120px]" />
      <div className="pointer-events-none absolute -right-20 top-0 h-72 w-72 rounded-full bg-lime/20 blur-[120px]" />

      <motion.p
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="relative text-xs font-semibold uppercase tracking-[0.3em] text-lime"
      >
        Your link is waiting
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="relative mx-auto mt-5 max-w-3xl font-display text-4xl font-semibold leading-[0.95] tracking-tighter text-bg md:text-6xl lg:text-7xl"
      >
        Give your audience{" "}
        <span className="relative inline-block">
          one link
          <motion.span
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.6, ease: [0.65, 0, 0.35, 1] }}
            className="absolute -bottom-1 left-0 h-[6px] w-full origin-left bg-lime"
          />
        </span>{" "}
        that does it all.
      </motion.h2>

      <motion.a
        href={ROUTES.register}
        data-testid="cta-primary-button"
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.25 }}
        className="group relative mt-10 inline-flex items-center gap-2 rounded-full bg-lime px-8 py-4 text-sm font-semibold text-limeText transition-transform hover:-translate-y-0.5"
      >
        Claim your BREELINK — free
        <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </motion.a>
    </div>
  </section>
);
